import React from 'react';
import { FormattedMessage } from 'react-intl';

import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import H3 from '../../../components/atoms/H3';
import H4 from '../../../components/atoms/H4';

import Buttons from './Buttons';
import Links from './Links';
import { Content, TitleWrapper, Wrapper } from './styled';

const NoVerse = () => {
  return (
    <Wrapper>
      <Content>
        <TitleWrapper>
          <H4>
            <FormattedMessage id="lounge.noVerse.noAccess" />
          </H4>
          <H3>
            <FormattedMessage id="lounge.noVerse.title" />
          </H3>
        </TitleWrapper>
        <Body
          size="medium"
          style={{
            color: colors.shade80,
            textAlign: 'center',
          }}
        >
          <FormattedMessage id="lounge.noVerse.description" />
        </Body>
        <Links />
      </Content>
      <Buttons />
    </Wrapper>
  );
};

export default NoVerse;
